export default __webpack_public_path__ + "images/da7757105666b5fc44a5942310d4c00e.svg";